import React from "react";
import PropTypes from "prop-types";

import Button from "@mui/material/Button";
import ButtonGroup from "@mui/material/ButtonGroup";

import { SECTIONS, SECTIONS_TITLES } from "../types";

const ToggleEntities = ({ currentSection, setCurrentSection }) => {
  return (
    <ButtonGroup size="small" aria-label="Small button group">
      {Object.values(SECTIONS).map((section, index) => (
        <Button
          key={index}
          variant={currentSection === section ? "contained" : "outlined"}
          onClick={() => setCurrentSection(section)}
        >
          {SECTIONS_TITLES[section]}
        </Button>
      ))}
    </ButtonGroup>
  );
};

ToggleEntities.propTypes = {
  currentSection: PropTypes.string,
  setCurrentSection: PropTypes.func
};

export default ToggleEntities;
